// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"2648d9d4035855dbbda0","966":"09cae41df43f0a9491fd"}[chunkId] + ".js";
};